import jQuery from 'jquery';

function closeGalleries() {
    jQuery('.gallery.fullscreen').removeClass('show');
}

function slickMediaGallery(selector) {
    jQuery(selector).each(function () {
        const parentId = jQuery(this).attr('id');

        const imagesCount = jQuery('.gallery-thumb', this).length;
        const navSlides = (imagesCount > 7) ? 7 : imagesCount - 1;

        const mobile = (jQuery(window).width() < 768);
        const multipleImages = (imagesCount > 7);

        let thumbnailsToShow = 0;

        if (mobile) {
            thumbnailsToShow = (imagesCount > 2) ? 2 : 1;
        } else if (multipleImages) {
            thumbnailsToShow = navSlides;
        } else {
            thumbnailsToShow = imagesCount;
        }

        jQuery(this).children('.gallery-boxes').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            centerMode: false,
            swipeToSlide: true,
            useCSS: false,
            asNavFor: multipleImages || mobile ? `#${parentId} .gallery-nav` : false,
            variableWidth: false,
            infinite: true,
            useTransform: true,
            centerPadding: 0,
            cssEase: 'ease-out',
            lazyLoad: 'ondemand',
            mobileFirst: true,
            adaptiveHeight: true,
            nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        });

        jQuery(this).children('.gallery-nav').slick({
            slidesToShow: thumbnailsToShow,
            slidesToScroll: 1,
            asNavFor: `#${parentId} .gallery-boxes`,
            dots: false,
            arrows: false,
            centerMode: multipleImages || mobile,
            focusOnSelect: true,
            variableWidth: !multipleImages && !mobile,
            infinite: multipleImages || mobile,
            swipeToSlide: multipleImages || mobile,
            mobileFirst: true,
            centerPadding: 0,
            cssEase: 'ease-out',
        });

        if (!multipleImages && !mobile) {
            jQuery(this).children('.gallery-boxes').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                jQuery(this).parent().children('.gallery-nav').find('.slick-slide')
                    .removeClass('slick-active')
                    .removeClass('slick-current')
                    .eq(nextSlide)
                    .addClass('slick-active')
                    .addClass('slick-current');
            });
        }

        // On after fullscreen gallery slide change
        if (jQuery(this).hasClass('fullscreen')) {
            jQuery(this).children('.gallery-boxes').on('afterChange', function () {
                const title = jQuery('.slick-current img', this).attr('title');

                jQuery(this).parent().find('.gallery-caption').html((title && title.length > 2) ? `<span>${title}</span>` : '');
            });
        }


        // Reload YouTube videos to stop them on slide change
        jQuery(this).children('.gallery-boxes').on('afterChange', () => {
            jQuery('.video-gallery iframe').each(function () {
                let video = jQuery(this).attr('src');
                video = video.replace('autoplay=1', 'autoplay=0');
                jQuery(this).attr('src', '');
                jQuery(this).attr('src', video);
            });
        });
    });

    jQuery('.gallery:not(.video-gallery) a').on('click', function (e) {
        e.preventDefault();

        const slideno = jQuery(this).parents('.slick-slide').data('slick-index');
        const galleryId = jQuery(this).data('gallery-id');

        const boxesCount = jQuery(`#gallery-${galleryId}`).find('.gallery-boxes .gallery-box').length;

        if (boxesCount > 1) {
            jQuery(`#gallery-fullscreen-${galleryId} .gallery-boxes`).slick('slickGoTo', slideno, true);
        }

        jQuery(`#gallery-fullscreen-${galleryId}`).addClass('show');
    });


    // Close on Escape or Close button
    jQuery('.gallery-close').on('click', () => {
        closeGalleries();
    });
    jQuery(document).keyup((e) => {
        if (e.key === 'Escape') {
            closeGalleries();
        }
    });
}

export default slickMediaGallery;
